import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { budgetDetailsPeriodSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsPeriodSelector";
import { budgetDetailsStartDateSelector } from "@/store/budgets/selectors/details-drawer/budgetDetailsStartDateSelector";
import { organisationQuarterStartMonthSelector } from "@/store/common/selectors/org-current-settings/organisationQuarterStartMonthSelector";
import { getBudgetDetailsAccumulatedCostMonthlyDateOptions } from "@/store/budgets/utils/helpers/getBudgetDetailsAccumulatedCostMonthlyDateOptions";
import { getBudgetDetailsAccumulatedCostQuarterlyDateOptions } from "@/store/budgets/utils/helpers/getBudgetDetailsAccumulatedCostQuarterlyDateOptions";
import { getBudgetDetailsAccumulatedCostAnnuallyDateOptions } from "@/store/budgets/utils/helpers/getBudgetDetailsAccumulatedCostAnnuallyDateOptions";

export const budgetDetailsAccumulatedCostDateOptionsSelector =
  createDraftSafeSelector(
    [
      budgetDetailsPeriodSelector,
      budgetDetailsStartDateSelector,
      organisationQuarterStartMonthSelector,
    ],
    (period, startDate, quarterStartMonth) => {
      if (!startDate) {
        return [];
      }

      if (period === "monthly") {
        return getBudgetDetailsAccumulatedCostMonthlyDateOptions(startDate);
      }

      if (period === "quarterly") {
        return getBudgetDetailsAccumulatedCostQuarterlyDateOptions(
          startDate,
          quarterStartMonth,
        );
      }

      if (period === "annually") {
        return getBudgetDetailsAccumulatedCostAnnuallyDateOptions(startDate);
      }

      return [];
    },
  );
